// extracted by mini-css-extract-plugin
export var defaultWrapper = "_ie-3";
export var downloadButton = "_ie-4";
export var fileContainer = "_ie-9 _ie-7";
export var fileContainerBase = "_ie-7";
export var fileContainerBaseSm = "_ie-a _ie-7";
export var fileContainerFixedHeight = "_ie-8 _ie-7";
export var fileContainerFixedHeightSm = "_ie-c _ie-a _ie-7";
export var fileContainerSm = "_ie-b _ie-a _ie-7";
export var fileInfo = "_ie-5";
export var fileInfoWidthRestricted = "_ie-6";
export var fileType = "_ie-1";
export var fileTypeName = "_ie-2";
export var fileTypeSm = "_ie-d _ie-1";
export var image = "_ie-0";
export var link = "_ie-f";
export var overflowEllipsis = "_ie-e";